module.exports = __webpack_public_path__ + "static/media/owlsome-patent.253324d7.jpg";